import { ReactNode } from 'react';
import { TextKey } from '@mews-commander/enums';
import { LocalizedText } from '@mews/framework';
import { Banner, Order, Table, TableHeader, TableProvider, useTableState } from '@optimus-web/core';
import { PrivilegesTableColumns, useColumns } from './tableMapping';
import { usePrivilegesFilter } from './utils';

interface PrivilegesTableProps {
    error?: ReactNode;
    rowSelection: Record<string, boolean>;
    handleRowSelectionChange: (value: Record<string, boolean>) => void;
}

export const PrivilegesTable = ({ rowSelection, handleRowSelectionChange, error }: PrivilegesTableProps) => {
    const [tableState, setTableState] = useTableState<PrivilegesTableColumns>({
        pagination: { show: false },
        sort: { value: { order: Order.Ascending, priority: 0 } },
    });

    const privileges = usePrivilegesFilter({
        searchTerm: tableState.globalFilters.search,
        sortOrder: tableState.sort.value?.order,
    });
    const totalRows = privileges.length;

    const columns = useColumns({ rowSelection, handleRowSelectionChange });

    return (
        <TableProvider columns={columns} state={tableState} onStateChange={setTableState}>
            <TableHeader
                title={<LocalizedText textKey={TextKey.Privileges} />}
                globalSearch={{ placeholder: <LocalizedText textKey={TextKey.PrivilegesSearchHint} /> }}
            />

            {error ? <Banner primaryText={error} variant="error" /> : null}

            <Table amountOfRows={totalRows} data={privileges} uniqueRowId="value" />
        </TableProvider>
    );
};
